import { orgFromFirestore } from '@parallel-fluidics/shared/models/organizations';
import useRealtimeDocs from 'hooks/use-realtimeDocs';
import { useMemo } from 'react';

import getAllOrgsQuery from '../api/getAllOrgsQuery';

export default function useRealtimeOrgs() {
  const orgQuery = useMemo(() => getAllOrgsQuery(), []);

  return useRealtimeDocs({
    query: orgQuery,
    transformData: orgFromFirestore,
  });
}
